<template>
  <div>
    <v-divider class="mt-4"></v-divider>
    <v-card-title>
      <h3 class="font-weight-bold">{{ descTitle }}</h3>
    </v-card-title>
    <v-card-text class="formatText" v-html="text"> </v-card-text>
    <v-divider></v-divider>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  props: {
    descTitle: {
      type: String,
    },
    text: {
      type: String,
    },
  },
});
</script>

<style scoped lang="scss">
.formatText {
  white-space: pre-wrap;
}
</style>
